import React, {useEffect,useContext,useState} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../../contexts";
import reactionCombiner from "../../../utils/reactionCombiner";
import SmallMode from "./SmallMode";
import BigMode from "./BigMode";
import DataExporter from "../../Helpers/DataExporter";

function MultiFile(props) {
  const store = useLocalObservable(() => ({
    opened:false,
    index:0,
  }));
  const compStore=useContext(ComponentContext);
  const [comb, setComb] = useState(new reactionCombiner());

  useEffect(() => {
    // mount

    if(!compStore.data.hasOwnProperty("length")) {
      runInAction(()=>{
        compStore.data=[];
      });
    }

    return () => {
      // unmount
    }
  }, []);

  return (
    <>
      <SmallMode  onOpen={()=>{
        runInAction(()=>{
          store.opened=true;
        });
      }} />
      {store.opened?<BigMode onClose={()=>{
        runInAction(()=>{
          store.opened=false;
        });
      }} />:null}
      <DataExporter />
    </>
  );
};

MultiFile.defaultProps = {};

MultiFile.propTypes = {}

export default observer(MultiFile);
